<template>
  <div class="page_title">
    <div class="row">
      <div class="row-left">
        <i class="el-icon-arrow-left back" v-if="back" @click="goBack"></i>
        <div class="text">{{ text }}</div>
        <Competition v-if="$route.name === 'main'"></Competition>
      </div>
      <div class="row-right">
        <template v-if="!isPersonal">
          <div class="guide-btn">
            <Guide></Guide>
          </div>
          <el-popover placement="top" width="240" trigger="hover">
            <div class="certimg">
              <strong style="font-size:18px;text-align:center;display:block;">手机端扫码查询证书</strong>
              <img src="@/assets/cert.png" style="width:200px;display:block;margin:auto;" alt="cert" />
            </div>
            <i class="el-icon-mobile-phone" slot="reference"></i>
          </el-popover>
          <div class="el-button el-button--primary el-button-cert" @click="toCert">证书查询</div>
        </template>
        <div class="logout" @click="logout"><i class="icon"></i>退出</div>
      </div>
    </div>
  </div>
</template>
<script>
import { logout } from "@/api/user.js";
import { removeToken } from "@/utils/auth";
import { MessageBox, Message } from 'element-ui'
import Competition from './Competition'
import Guide from '@/components/Guide.vue'
export default {
  name: "page_title",
  components: { Guide, Competition },
  props: {
    text: {
      type: String,
      default: "",
    },
    back: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    /**
     * 判断是否为个人用户，个人用户不显示指南、证书查询等入口
     */
    isPersonal() {
      return window.localStorage.getItem("role") === "1";
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    // cert(){
    // 	this.$router.go('https://cert.ktnw.cn/search/?id=18');
    // },
    toCert() {
      window.open('https://cert.ktnw.cn/group/?groupTypeId=2');
      // MessageBox.confirm("系统仅可查询第二届（我的家乡）征文活动证书，第三届（新发展 向未来）活动证书查询时间待定！", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // }).then(() => {

      // }).catch(e=>{
      // })
    },
    logout() {
      MessageBox.confirm("是否退出登录？", "登录提示", {
        confirmButtonText: "确定退出",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        logout().then((d) => {
          removeToken();
          this.$router.push("/");
        });
      }).catch(e => {

      })
    },
  },
};
</script>
<style lang="scss" scoped>
$defaultRed: #6e3621;

.page_title {
  height: 56px;
  color: #6e3621;
  border-bottom: 2px solid $defaultRed;

  .row {
    display: flex;
    justify-content: space-between;
    align-items: center
  }

  .row-left,
  .row-right {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .guide-btn {
    margin-right: 20px;
  }

  .el-button-cert {
    text-decoration: none;
  }

  .el-icon-mobile-phone {
    font-size: 24px;
    margin-right: 20px;
    cursor: pointer;
  }

  .back {
    margin-right: 15px;
    font-size: 32px;
    font-weight: bold;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
  }

  .text {
    font-weight: 700;
    font-size: 24px;
  }

  .logout {
    font-size: 14px;
    color: #565656;
    cursor: pointer;
    margin-left: 20px;

    i {
      display: inline-block;
      margin-top: -2px;
      margin-right: 5px;
      width: 18px;
      height: 20px;
      background: url("../assets/icon_logout.png");
      vertical-align: middle;
    }

    &:hover {
      color: $defaultRed;
    }
  }
}
</style>